/**
 * Utility Functions Module
 * Các hàm tiện ích dùng chung
 */

/**
 * Debounce utility
 */
export function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

/**
 * Price formatting helper
 * Hiển thị giá bình thường cho tất cả các variation (kể cả "1 Kèm 1 Chứng từ của HV")
 */
export function formatPrice(value, variationLabel = '') {
    const number = parseFloat(value) || 0;

    // [DISABLED] Logic cũ: Hiển thị "Liên Hệ" cho variation "1 Kèm 1 Chứng từ của HV"
    // Đã comment vì giá đã được cập nhật tự động từ script update-chungtu-price.php
    // if (variationLabel && variationLabel.toLowerCase().includes('1 kèm 1 chứng từ của hv')) {
    //     return '<span class="lien-he-price">Liên Hệ</span>';
    // }

    // Hiển thị giá bình thường (kể cả 0đ)
    return number.toLocaleString('vi-VN') + 'đ';
}

/**
 * Escape HTML
 */
export function escapeHtml(text) {
    if (!text) {
        return '';
    }
    return text.replace(/[&<>"']/g, function(m) {
        return ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;',
        })[m];
    });
}

/**
 * Strip HTML tags and return plain text
 * Used for content from rich text editors (e.g., Quill) that may contain HTML
 */
export function stripHtml(html) {
    if (!html) {
        return '';
    }
    // Create a temporary element to parse HTML and extract text
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    // Get text content (strips all tags)
    return tempDiv.textContent || tempDiv.innerText || '';
}

/**
 * Format date from YYYY-MM-DD to DD/MM/YYYY
 */
export function formatDateDDMMYYYY(dateString) {
    if (!dateString) {
        return '';
    }

    // Handle both YYYY-MM-DD and YYYY-MM-DD HH:MM:SS formats
    const datePart = dateString.split(' ')[0];
    const parts = datePart.split('-');

    if (parts.length !== 3) {
        return dateString; // Return original if format is unexpected
    }

    const year = parts[0];
    const month = parts[1];
    const day = parts[2];

    return day + '/' + month + '/' + year;
}

/**
 * Find variation with lowest price
 */
export function findLowestPriceVariation(variations) {
    if (!variations || variations.length === 0) {
        return null;
    }

    let lowestPriceVar = variations[0];
    let lowestPrice = parseFloat(lowestPriceVar.price) || 0;

    variations.forEach(variation => {
        const price = parseFloat(variation.price) || 0;
        if (price < lowestPrice) {
            lowestPrice = price;
            lowestPriceVar = variation;
        }
    });

    return lowestPriceVar;
}

/**
 * Find variation by name/attribute containing specific text
 * Used for finding "TỰ HỌC" variation for free courses
 */
export function findVariationByName(variations, searchText) {
    if (!variations || variations.length === 0) {
        return null;
    }

    // Normalize search text for comparison
    const normalizedSearch = searchText.toLowerCase().trim();

    // Try to find by formatted_attributes first
    for (const variation of variations) {
        if (variation.formatted_attributes) {
            const attributeValues = Object.values(variation.formatted_attributes);
            for (const value of attributeValues) {
                if (value && value.toLowerCase().includes(normalizedSearch)) {
                    return variation;
                }
            }
        }
    }

    // Fallback: try to find by description
    for (const variation of variations) {
        if (variation.description && variation.description.toLowerCase().includes(normalizedSearch)) {
            return variation;
        }
    }

    // If not found, return first variation as fallback
    return variations[0];
}

/**
 * Scroll to field and highlight with error
 */
export function scrollToFieldAndHighlight(field) {
    // Support both jQuery object and selector string
    if (typeof field === 'string') {
        field = jQuery(field);
    }

    // Add error class
    field.addClass('ktvhvn-field-error');

    // Scroll to the field
    jQuery('html, body').animate({
        scrollTop: field.offset().top - 100
    }, 400, function() {
        // Focus after scroll complete
        field.focus();
    });
}
